import React from 'react';

import { SVGComponentProps } from './svg.types';

const ShrinkArrowSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        d="M3.99844 10.2934V9.42241L1.6551 11.7509C1.32046 12.0836 0.779449 12.0829 0.445636 11.7494L0.250799 11.5547C-0.0835996 11.2206 -0.0835999 10.6789 0.250799 10.3447L2.56502 8.03208L1.67963 8.05347C1.41381 8.05676 1.15757 7.9544 0.967273 7.76892C0.776981 7.58343 0.668226 7.33001 0.664933 7.06441C0.66164 6.7988 0.76408 6.54277 0.949715 6.35263C1.13535 6.16249 1.38897 6.05382 1.65479 6.05053L4.98317 6.00005C5.11529 5.99869 5.24636 6.02355 5.3688 6.07319C5.49123 6.12282 5.60259 6.19624 5.69642 6.2892C5.79025 6.38215 5.86467 6.49279 5.91539 6.6147C5.9661 6.73661 5.9921 6.86736 5.99187 6.99938L5.99957 10.2934C6.00349 10.4272 5.98051 10.5603 5.93198 10.685C5.88346 10.8098 5.81039 10.9235 5.71709 11.0195C5.62379 11.1155 5.51217 11.1918 5.38882 11.2439C5.26548 11.296 5.13292 11.3228 4.99901 11.3228C4.86509 11.3228 4.73254 11.296 4.60919 11.2439C4.48585 11.1918 4.37422 11.1155 4.28092 11.0195C4.18762 10.9235 4.11455 10.8098 4.06603 10.685C4.01751 10.5603 3.99452 10.4272 3.99844 10.2934Z"
        fill={fill}
      />
      <path
        d="M8.00156 1.7066V2.57759L10.3449 0.249098C10.6795 -0.0836168 11.2206 -0.0829463 11.5544 0.250597L11.7492 0.445276C12.0836 0.779405 12.0836 1.32113 11.7492 1.65526L9.43498 3.96792L10.3204 3.94653C10.5862 3.94324 10.8424 4.0456 11.0327 4.23108C11.223 4.41657 11.3318 4.66999 11.3351 4.93559C11.3384 5.2012 11.2359 5.45723 11.0503 5.64737C10.8647 5.83751 10.611 5.94618 10.3452 5.94947L7.01684 5.99995C6.88471 6.00131 6.75364 5.97645 6.6312 5.92682C6.50877 5.87718 6.39741 5.80376 6.30358 5.7108C6.20975 5.61785 6.13533 5.50721 6.08461 5.3853C6.0339 5.26339 6.0079 5.13264 6.00813 5.00062L6.00043 1.7066C5.99651 1.57284 6.01949 1.43967 6.06802 1.31495C6.11654 1.19024 6.18961 1.07652 6.28291 0.980526C6.37621 0.884536 6.48783 0.808227 6.61118 0.756118C6.73452 0.704009 6.86708 0.67716 7.00099 0.67716C7.13491 0.67716 7.26746 0.704009 7.39081 0.756118C7.51415 0.808227 7.62578 0.884536 7.71908 0.980526C7.81238 1.07652 7.88545 1.19024 7.93397 1.31495C7.98249 1.43967 8.00548 1.57284 8.00156 1.7066Z"
        fill={fill}
      />
    </svg>
  );
};

export default ShrinkArrowSVG;
